import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from 'src/apis/baseQuery';
import {
  DataDTOCashTransactionSummary,
  DataDTOOrderHistoryItemList,
  DataDTOPagedDataDataDTOStationList,
  DataDTOPagedDataDataDTOTransactionHistory
} from 'src/types/api/generated/api';
import { PaginationParams } from 'src/types/common';

export const cashTransactionReportAPI = createApi({
  reducerPath: 'cashTransactionReportAPI',
  baseQuery: axiosBaseQueryWithReauth({
    baseUrl: process.env.REACT_APP_API_URL
  }),
  endpoints: builder => ({
    getCashTransactions: builder.query<
      DataDTOPagedDataDataDTOTransactionHistory,
      PaginationParams & { clientId: number }
    >({
      query: ({ page, pageSize, orderBy, filters, searchTerm, clientId }) => ({
        url: 'Transactions',
        method: 'GET',
        params: {
          page,
          pageSize,
          orderBy,
          searchTerm,
          filters: filters ? JSON.stringify(filters) : undefined,
          clientId
        }
      })
    }),
    getCashTransactionSummary: builder.query<
      DataDTOCashTransactionSummary,
      {
        clientId: number;
        filters?: Record<string, unknown>;
        searchTerm?: string;
      }
    >({
      query: ({ clientId, filters, searchTerm }) => ({
        url: 'Transactions/Cash/summary',
        method: 'GET',
        params: {
          clientId,
          filters: filters ? JSON.stringify(filters) : undefined,
          searchTerm
        }
      })
    }),
    getCashTransactionItems: builder.query<
      DataDTOOrderHistoryItemList[],
      number
    >({
      query: transactionId => ({
        url: `Transactions/${transactionId}`,
        method: 'GET'
      })
    }),
    getCashReportStations: builder.query<
      DataDTOPagedDataDataDTOStationList,
      PaginationParams & { clientId: number }
    >({
      query: ({ page, pageSize, orderBy, filters, searchTerm, clientId }) => ({
        url: 'Stations',
        method: 'GET',
        params: {
          page,
          pageSize,
          orderBy,
          searchTerm,
          filters: filters ? JSON.stringify(filters) : undefined,
          clientId
        }
      })
    })
  })
});

export const {
  useLazyGetCashTransactionsQuery,
  useLazyGetCashTransactionSummaryQuery,
  useGetCashTransactionItemsQuery,
  useGetCashReportStationsQuery
} = cashTransactionReportAPI;
